var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 70,
    viewBox: "0 0 417 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 35C341.139 35 353.32 26.616 358.842 14.5483C362.29 7.01536 368.716 0 377 0H402C410.284 0 417 6.71573 417 15V55C417 63.2843 410.284 70 402 70H15C6.71573 70 0 63.2843 0 55V15C0 6.71573 6.71573 0 15 0H277C285.284 0 291.71 7.01536 295.158 14.5483C300.68 26.616 312.861 35 327 35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationUser);
export default __webpack_public_path__ + "static/media/navigation_user.6ad8abc4affbb32fa5b78e0aa5737bb5.svg";
export { ForwardRef as ReactComponent };